import React from 'react'
import { connect } from 'react-redux'
import { Outlet, Navigate } from 'react-router-dom'






function PrivateRoutes(props) {
    return (
        <>
            {props.Login.auth ? <Outlet /> : <Navigate to="/Login" />}
        </>

    )

}


const mapStateToProps = (state) => ({
    Login:state.Login
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoutes);

